import * as types from "../../types/website/pricing";

export const requestSubscriptionPlans = () => ({
  type: types.SUBSCRIPTION_PLANS_REQUEST,
});
export const receiveSubscriptionPlans = (payload) => ({
  type: types.SUBSCRIPTION_PLANS_RECEIVE,
  payload,
});
